<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 项目管理 / 基金列表</span>
      </div>
    </div>
    <div style="overflow:hidden; padding:15px 15px; padding-top: 0; line-height: 43px ">
      <span class="leftTd">编码</span>
      <input class="boxText" v-model="code" style="width: 200px; margin-left: 10px;">
      <span class="leftTd" style="margin-left: 15px;">基金名称</span>
      <input class="boxText" v-model="name" style="width: 200px; margin-left: 10px;">
      <span class="leftTd" style="margin-left: 15px;">担保公司</span>
      <input class="boxText" v-model="company" style="width: 200px; margin-left: 10px;">

<!--      <span class="leftTd" style="margin-left: 15px;">状态</span>-->
<!--      <select class="boxText" v-model="state" style="width: 200px; margin-left: 10px;">-->
<!--        <option value="">全部</option>-->
<!--        <option value="待申购">待申购</option>-->
<!--        <option value="可申购">可申购</option>-->
<!--        <option value="已上市">已上市</option>-->
<!--      </select>-->
      <span class="leftTd" style="margin-left: 15px;">是否推荐</span>
      <select class="boxText" v-model="recommend" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option value="是">是</option>
        <option value="否">否</option>
      </select>
      <span class="leftTd" style="margin-left: 15px;">项目类型</span>
      <select v-model="className" class="boxText" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option value="涨幅榜">涨幅榜</option>
        <option value="稳健榜">稳健榜</option>
        <option value="人气榜">人气榜</option>
        <option value="新手榜">新手榜</option>
      </select>
      <input @click="selectAdminList" type="button" style="cursor: pointer; padding: 7px 25px; border-radius: 3px; margin-left: 10px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="搜索" />
    </div>
    <div style="overflow:hidden; padding:0 15px;">
      <div @click="addAdmin" class="addBtn">+ 添加基金</div>
    </div>
    <div style="padding: 10px 15px">
      <div style="overflow-x: scroll">
        <table>
          <tr>
            <th class="th">
              操作
            </th>
            <th class="th">
              项目ID
            </th>
            <th class="th">
              基金名称
            </th>
            <th class="th">
              基金编码
            </th>
            <th class="th">
              币种
            </th>
            <th class="th">
              推荐
            </th>
            <th class="th">
              项目类型
            </th>
            <th class="th">
              金币
            </th>
            <th class="th">
              浮动分红(%)
            </th>
            <th class="th">
              开始时间
            </th>
            <th class="th">周期</th>
            <th class="th">规模</th>
            <th class="th">最低起投</th>
            <th class="th">最高限制</th>
            <th class="th">进度(%)</th>
            <th class="th">利率(%)</th>
            <th class="th">加息(%)</th>
            <th class="th">担保机构</th>
            <th class="th">联动项目</th>
            <th class="th">联动金额</th>
            <th class="th">序列号</th>
            <th class="th">添加日期</th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td">
              <div style="overflow: hidden;min-width: 100px;">
                <div @click="updateAdmin(value)" style="cursor: pointer; float: left; color: #1890ff">
                  编辑
                </div>
                <div @click="addValue(value.projectId)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">
                  加息
                </div>
<!--                <div @click="breakProject(value.projectId)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">-->
<!--                  破发-->
<!--                </div>-->
                <div @click="deleteProject(value.projectId)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">
                  删除
                </div>
              </div>
            </td>
            <td class="td">
              {{ value.projectId }}
            </td>
            <td class="td">
              {{ value.projectName }}
            </td>
            <td class="td">
              {{value.projectCode}}
            </td>
            <td class="td">
              {{value.projectCurreny}}
            </td>
            <td class="td">
              {{value.projectRecommend}}
            </td>
            <td class="td">
              {{value.projectClass}}
            </td>

            <td class="td">
              {{'1:'+value.projectGold}}
            </td>
            <td class="td">
              {{ value.projectRebateValue }}
            </td>
            <td class="td">{{ value.projectBuyTime }}</td>
            <td class="td">{{ value.projectDay }}</td>
            <td class="td">{{ value.projectNum }}</td>
            <td class="td">{{ value.projectPrice }}</td>
            <td class="td">{{ value.projectMaxBuy }}</td>
            <td class="td">
              <input type="number" v-model="value.projectStock" @change="updateSchedule(value.projectId,value.projectStock)" class="text1" style="width: 50px; text-align: center" />
            </td>
            <td class="td">{{ value.projectRate }}</td>
            <td class="td">{{ value.projectAddRate }}</td>
            <td class="td">{{ value.projectCompany }}</td>
            <td class="td">{{ value.projectBindProject==''?'未联动':value.projectBindProject }}</td>
            <td class="td">{{ value.projectBindPrice==''?'未联动':value.projectBindPrice }}</td>
            <td class="td">{{ value.projectNumber }}</td>
            <td class="td">{{ value.projectTime }}</td>
          </tr>
        </table>
      </div>
      <div style="padding-top: 20px; font-size: 12px; color: #606266; text-align: right">
        一页显示 <input v-model="num" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/>
        条，共<span v-html="count"></span>条数据
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shouye.png" v-on:click="currPage(1)" title="首页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shangyiye.png" v-on:click="currPage(2)" title="上一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <input v-model="page" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/> / <span
          v-html="countPage"></span>页
        <img src="@/assets/home/xiayiye.png" v-on:click="currPage(3)" title="下一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/weiye.png" v-on:click="currPage(5)" title="尾页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "FundList",
  data(){
    return{
      className:"",
      code:"",
      name:"",
      company:"",
      state:"",
      recommend:"",
      adminList:[],
      page:1,
      num:10,
      count:0,
      countPage:0,
      imgUrl:"",
      levelList:[],
      teamLevelList:[]
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
  },
  methods: {
    deleteProject(id){
      
      let that=this
      if(confirm("确认删除此项目？删除需谨慎，一旦删除将无法恢复，所产生的投资信息将无法正常发放！")){
        axiosPost(DO_NET_URL+"project/DeleteProject?projectId="+id,"",function (res){
          console.log(res)
          if(res.code==200){
            toask("删除成功！",6)
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    updateSchedule(id,e){
      if(e==""){
        toask("进度不能为空！",6)
        return
      }
      axiosPost(DO_NET_URL+"project/UpdateScheduleByFund?projectId="+id+"&projectSchedule="+e,function (res){

      })
      console.log(id)
      console.log(e)
    },
    addValue(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","addRate")
    },
    breakProject(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","breakProject")
    },
    childUser(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","childUser")
    },
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",JSON.stringify(obj))
      this.$emit("send",'updateFund')
    },

    addAdmin(){
      this.$emit("send",'addFund')
    },
    currPage(num){
      if(num==1){
        this.page=1
      }else if(num==5){
        this.page=this.countPage
      }else if(num==2){
        if(this.page>1){
          this.page-=1
        }
      }else{
        if(this.page<this.countPage){
          this.page+=1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      axiosGet(DO_NET_URL+"project/GetFund?className="+this.className+"&code="+this.code+"&name="+this.name+"&company="+this.company+"&state="+this.state+"&recommend="+this.recommend+
          "&page="+this.page+"&num="+this.num,function (res){
        console.log(res.data)
        closeLoading()
        that.imgUrl=res.data.imgUrl
        that.adminList=res.data.list
        that.count=res.data.num
        let page=parseInt(res.data.num/that.num)
        if(res.data.num%that.num>0){
          page+=1
        }
        that.countPage=page
        localStorage.setItem("imgUrl",res.data.imgUrl)
      })
    },
  }
}
</script>

<style scoped>
.text1{
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700;}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0px 10px; min-width: 100px; width: auto; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>